module.exports = __webpack_public_path__ + "img/owl-icon.19fcd0f1.svg";